import _ from 'lodash'
import 'lightgallery.js'
import common from './common'

export default {
  init() {
    this.galleryColumns = null // 初期化

    // Gellery ----------------
    this.wrapImages()
    this.adjustHeight()

    // lightGallery (Popup)
    const lg = document.querySelector('.gallery')
    if(lg) {
      lightGallery(lg, {
        selector: 'img[data-src]',
        download: false,
        counter: false,
        controls: true, // SPではfalseで良いが、リサイズで変わることも考慮してcss側で無効化する
        mousewheel: true,
        backdropDuration: 250,
        startClass: '' // cancel 'lg-start-zoom'
      })
      const body = $('body')
      lg.addEventListener('onAfterOpen', () => { body.addClass('noscroll') }, false)
      lg.addEventListener('onBeforeClose', () => { body.removeClass('noscroll') }, false)
      // ズームした画像を別タブで開く（[こちら](https://karappo.slack.com/archives/C013X8PM345/p1731562795723989?thread_ts=1731303623.494509&cid=C013X8PM345)の理由によりやめることになった）
      // lg.addEventListener('onSlideClick', () => {
      //   const index = window.lgData[lg.getAttribute('lg-uid')].index
      //   const imgSrc = lg.querySelectorAll('img')[index].getAttribute('data-src')
      //   window.open(imgSrc, '_blank');
      // });
    }

    $(document).on('click', '.closeProjectStory, #projectStory>.close', this.closeStory)
    $(document).on('click', 'a[data-modal="story"]', this.openStory)
    // はじめから#sotryがついていたらモーダルを開く
    if(location.hash === '#story') {
      this.openStory()
    }
  },
  beforeLeave() {
    $(document).off('click', '.closeProjectStory, #projectStory>.close', this.closeStory)
    $(document).off('click', 'a[data-modal="story"]', this.openStory)
    $('#projectStory').empty()
  },
  resize() {
    this.wrapImages()
    this.adjustHeight()
  },
  // ===================================
  // private functions
  openStory() {
    $('#projectStory').html($('#projectStoryContent').html())
    common.enableMultipleLineBorderheading('#projectStory section.content')
    $('body').addClass('noscroll')
    setTimeout(() => {
      $('#projectStory').addClass('active')
    }, 100)
    history.replaceState('', '', '#story') // URLは変えるが、履歴には残さない
  },
  closeStory() {
    if(location.hash !== '#story') {
      return
    }
    $('body').removeClass('noscroll')
    $('#projectStory').removeClass('active')
    window.history.replaceState('', '/', window.location.pathname) // URLは変えるが、履歴には残さない
  },

  // imgを.rowでwrapする
  wrapImages() {
    // 画面サイズに応じて標準カラム数を変更
    const w = $(window).width()
    let columns = 3
    if (w < 729) { // $threshold5 in stylesheets
      columns = 1
    } else if (w <= 1779) { // $threshold1 in stylesheets
      columns = 2
    }
    if (this.galleryColumns === columns) { return } // カラム数が変わっていなければ何もしない
    this.galleryColumns = columns

    // -----------------------------------
    // リセット

    // wrap済みだったらもとに戻す
    $('section.gallery .row').each(function () {
      $(this).contents().unwrap()
    })
    // 直書きされた高さをクリア
    $('section.gallery > img').removeAttr('style')

    // -----------------------------------

    // 1列の場合は何もしない
    if (columns === 1) { return }

    // -----------------------------------

    // img を .rowにまとめる
    // - 1つだけ余らないよう最後の行は3つになってもよい
    // -
    const images = $('section.gallery > img').toArray()
    const rows = _.chunk(images, columns)
    if (1 < images.length) {
      const remainder = images.length % columns
      if (remainder !== 0) {
        if (columns == 2) {
          // 2列
          // 一つ前の行に移動して、最後の行を3列にする
          rows[rows.length - 2] = rows[rows.length - 2].concat(rows.pop())
        } else {
          // 3列
          if (remainder === 1) {
            // 前の行から一つ移動させて2列にし、最後の行も2列にする
            rows[rows.length - 1] = rows[rows.length - 1].concat(rows[rows.length - 2].pop())
            // 最後から2つめの行が両方縦長画像だった場合は大きくなりすぎるので最後の行にまとめる
            const portraits = _.filter(rows[rows.length - 2], (c) => $(c).attr('width') < $(c).attr('height'))
            if (2 <= portraits.length) {
              rows[rows.length - 2] = rows[rows.length - 2].concat(rows[rows.length - 1])
              rows.pop()
            }
          } else if (remainder === 2) {
            // そのままで問題ない
          } else {
            // あまりの数がおかしい
            console.error('Somthing wrong...')
          }
        }

      }
    }
    rows.map(function(el) {
      $(el).wrapAll('<div class="row"></div>')
    })
  },
  // wrap済みimgの高さを調整
  adjustHeight() {
    const galleryWidth = $('section.gallery').width()
    let margin = null
    $('section.gallery .row').each(function() {
      const columns = $(this).find('img').toArray()
      if (!margin) {
        // 全て同じはずなので一度だけ計算
        margin = parseInt($(columns[columns.length - 1]).css('marginLeft'), 10)
      }
      // 一旦高さを合わせる（どちらでも良いが、最小に）
      const minHeight = _.min(columns.map(function(el) { return parseInt($(el).attr('height'),10) }))
      $(columns).height(minHeight).width('auto')

      const restWidth = galleryWidth - margin * (columns.length - 1)
      let totalWidth = 0
      columns.map(function(el) { totalWidth += $(el).width() })
      const height = parseInt(minHeight * restWidth / totalWidth, 10)
      $(columns).height(height)
    })
  }
}
